import React from "react";
import {ButtonInProjectCard} from "./ButtonStyles";
import styled from "styled-components";

const LinksButton = ({ setIsOpen }) => {
    return (
        <Btn onClick={() => setIsOpen(true)}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="12" fill="#3394F6"/>
                <path
                    d="M11.325 17H7.5C6.255 17 5.19375 16.5125 4.31625 15.5375C3.43875 14.5625 3 13.3833 3 12C3 10.6167 3.43875 9.4375 4.31625 8.4625C5.19375 7.4875 6.255 7 7.5 7H11.325V8.5H7.5C6.63 8.5 5.8875 8.84167 5.2725 9.525C4.6575 10.2083 4.35 11.0333 4.35 12C4.35 12.9667 4.6575 13.7917 5.2725 14.475C5.8875 15.1583 6.63 15.5 7.5 15.5H11.325V17ZM8.5125 12.75V11.25H15.4875V12.75H8.5125ZM12.675 17V15.5H16.5C17.37 15.5 18.1125 15.1583 18.7275 14.475C19.3425 13.7917 19.65 12.9667 19.65 12C19.65 11.0333 19.3425 10.2083 18.7275 9.525C18.1125 8.84167 17.37 8.5 16.5 8.5H12.675V7H16.5C17.745 7 18.8062 7.4875 19.6837 8.4625C20.5612 9.4375 21 10.6167 21 12C21 13.3833 20.5612 14.5625 19.6837 15.5375C18.8062 16.5125 17.745 17 16.5 17H12.675Z"
                    fill="#FAFAFA"/>
            </svg>

            <p> Accèder aux ressources / livrables </p>
        </Btn>
    )
}

const Btn = styled(ButtonInProjectCard)`
`


export default LinksButton